<template>
    <div v-wechat-title="$route.meta.title">
        <div class="tags" v-if="showTags">
            <ul>
                <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}"
                    :key="index">
                    <div v-if="isActive(item.path)">
                    </div>
                    <router-link :to="item.path" class="tags-li-title">
                        {{item.title}}
                    </router-link>
                    <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
                </li>
            </ul>
            <div class="tags-close-box">
                <el-dropdown @command="handleTags">
                    <el-button type="primary">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu size="small" slot="dropdown">
                        <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                        <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from "./Eventbus";

    export default {
        data() {
            return {
                tagsList: this.global.tagsList
            };
        },
        methods: {
            isActive(path) {
                return path === this.$route.fullPath;
            },
            // 关闭单个标签
            closeTags(index) {
                const delItem = this.tagsList.splice(index, 1)[0];
                const item = this.tagsList[index]
                    ? this.tagsList[index]
                    : this.tagsList[index - 1];
                if (item) {
                    delItem.path === this.$route.fullPath && this.$router.push(item.path);
                } else {
                    this.$router.push("/");
                }
            },
            // 关闭全部标签
            closeAll() {
                this.tagsList = [];
                this.$router.push("/");
            },
            // 关闭其他标签
            closeOther() {
                const curItem = this.tagsList.filter(item => {
                    return item.path === this.$route.fullPath;
                });
                this.tagsList = curItem;
            },
            // 设置标签
            setTags(route) {
                bus.$emit("tags", this.tagsList);
                const isExist = this.tagsList.some(item => {
                    return item.path === route.fullPath;
                });
                if (!isExist) {
                    if (this.tagsList.length >= 8) {
                        this.tagsList.shift();
                    }
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath,
                        name: route.matched[1].components.default.name
                    });
                }
                bus.$emit("tags", this.tagsList);
            },
            handleTags(command) {
                command === "other" ? this.closeOther() : this.closeAll();
            }
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            }
        },
        watch: {
            $route(newValue,) {
                this.setTags(newValue);
            }
        },
        created() {
            this.setTags(this.$route);
        }
    };
</script>


<style lang="scss" scoped>
// @import "../../../static/css/common";
    .tags {
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        overflow: hidden;
        background-color: rgba(103, 194, 58, 0.1);
        border-bottom: 1px solid #DAE3F2;
        z-index: 2;
    }

    .tags ul {
        flex-grow: 1;
    }

    .tags-li {
        float: left;
        margin: 3px 5px 2px 3px;
        border-radius: 3px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        height: 23px;
        line-height: 23px;
        border: 1px solid #e9eaec;
        background: #fff;
        padding: 0 5px 0 12px;
        vertical-align: middle;
        color: #666;
        -webkit-transition: all 0.3s ease-in;
        -moz-transition: all 0.3s ease-in;
        transition: all 0.3s ease-in;
    }

    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }

    .tags-li.active {
        color: #fff;
        background-color: #67C23A;
    }

    .tags-li-title {
        float: left;
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
    }

    .tags-li.active .tags-li-title {
        color: #fff;
    }

    .tags-close-box {

    }
</style>
